__turbopack_context__.v({
  "backgroundGrid": "PlatformIndexLogin-module__Gy2WXq__backgroundGrid",
  "card": "PlatformIndexLogin-module__Gy2WXq__card",
  "errorBox": "PlatformIndexLogin-module__Gy2WXq__errorBox",
  "fieldControl": "PlatformIndexLogin-module__Gy2WXq__fieldControl",
  "fieldGroup": "PlatformIndexLogin-module__Gy2WXq__fieldGroup",
  "footer": "PlatformIndexLogin-module__Gy2WXq__footer",
  "header": "PlatformIndexLogin-module__Gy2WXq__header",
  "loginButton": "PlatformIndexLogin-module__Gy2WXq__loginButton",
  "logo": "PlatformIndexLogin-module__Gy2WXq__logo",
  "page": "PlatformIndexLogin-module__Gy2WXq__page",
  "passwordToggle": "PlatformIndexLogin-module__Gy2WXq__passwordToggle",
  "passwordWrap": "PlatformIndexLogin-module__Gy2WXq__passwordWrap",
  "wrap": "PlatformIndexLogin-module__Gy2WXq__wrap",
});
